import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import ContractRateService from "../../../../services/rates/ContractRateService";

export const REQUEST_CREATE_CONTRACT_RATE = "REQUEST_CREATE_CONTRACT_RATE";
export const CREATE_CONTRACT_RATE_SUCCESS = "CREATE_CONTRACT_RATE_SUCCESS";
export const CREATE_CONTRACT_RATE_ERROR = "CREATE_CONTRACT_RATE_ERROR";

function requestCreateContractRate() {
  return {
    type: REQUEST_CREATE_CONTRACT_RATE,
  };
}

function createContractRateSuccess(json) {
  return {
    type: CREATE_CONTRACT_RATE_SUCCESS,
    message: json.data,
  };
}

function createContractRateError(json) {
  return {
    type: CREATE_CONTRACT_RATE_ERROR,
    error: json.data,
  };
}

export function createContractRate(payload) {
  return (dispatch) => {
    dispatch(requestCreateContractRate());
    return ContractRateService.postContract(payload).then((json) => {
      if (json.data.code === 200) {
        dispatch(createContractRateSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(createContractRate(payload));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(createContractRateError(json.data));
      }
    });
  };
}
